import { Decision } from '@/shared/api/protocol-ts/model/dto_report_common_pb';
import { Certainty } from '@/shared/api/protocol-ts/model/dto_report_certainty_pb';

export const conditionHasModelData = (certainty?: Certainty): boolean =>
  Boolean(
    certainty &&
      (certainty.ModelScore > 0 ||
        certainty.IsModelScoreSet ||
        certainty.ModelDecision !== Decision.NoDecision),
  );
